import monthsFile from "@/data/gst-months.json";
import { BRAND } from "@/data/site";

export const WA_NUMBER = BRAND.whatsapp.replace(/[^\d]/g, "");
export const waLink = (text) =>
  `https://wa.me/${WA_NUMBER}?text=${encodeURIComponent(text)}`;

export const YEARS = monthsFile.years;

const MONTH_NAME = (slug) =>
  slug.replace(/-\d{4}$/, "").replace(/^\w/, (c) => c.toUpperCase());

export const getMonthYear = (slug) => {
  const year = slug.match(/-(\d{4})$/)?.[1] || "";
  return { monthName: MONTH_NAME(slug), year };
};

export const isValidMonth = (slug) => /^[a-z]+-\d{4}$/.test(slug) && !!monthsFile.months[slug];

export const getMonthData = (slug) => monthsFile.months[slug] || null;

const MONTH_ORDER = [
  "january","february","march","april","may","june","july",
  "august","september","october","november","december",
];

const sortKey = (slug) => {
  const year = Number(slug.match(/-(\d{4})$/)?.[1] || 0);
  const month = MONTH_ORDER.indexOf(slug.replace(/-\d{4}$/, ""));
  return year * 12 + month;
};

export const MONTH_SLUGS = Object.keys(monthsFile.months).sort((a, b) => sortKey(a) - sortKey(b));

export const monthsForYear = (year) => MONTH_SLUGS.filter((s) => s.endsWith(`-${year}`));

export const prevNext = (slug) => {
  const i = MONTH_SLUGS.indexOf(slug);
  return {
    prev: i > 0 ? MONTH_SLUGS[i - 1] : null,
    next: i >= 0 && i < MONTH_SLUGS.length - 1 ? MONTH_SLUGS[i + 1] : null,
  };
};

// Illustrative, clearly-fictional sample rows per month (deterministic)
const SAMPLES = [
  ["Kaveri Trading Co.", "27AABCK", "Maharashtra", "Proprietorship"],
  ["Aurelia Design Studio", "24AAGCA", "Gujarat", "Partnership"],
  ["Brightline Logistics", "29AABCB", "Karnataka", "Pvt Ltd"],
  ["Shree Ganesh Kirana", "09AABCS", "Uttar Pradesh", "Proprietorship"],
  ["Coastline Marine Foods", "32AAXXC", "Kerala", "Partnership"],
];

export const getSampleRows = (slug) => {
  const { monthName, year } = getMonthYear(slug);
  return SAMPLES.map(([c, g, s, t], i) => ({
    company: c,
    gstin: `${g}${String(1234 + i * 111)}A1Z${String.fromCharCode(70 + i)}`.toUpperCase(),
    state: s,
    type: t,
    date: `${String(4 + i * 6).padStart(2, "0")}-${monthName.slice(0, 3)}-${year}`,
    blur: i >= 2,
  }));
};

export const ALL_STATES_UTS = [
  "Andhra Pradesh","Arunachal Pradesh","Assam","Bihar","Chhattisgarh","Goa","Gujarat","Haryana",
  "Himachal Pradesh","Jharkhand","Karnataka","Kerala","Madhya Pradesh","Maharashtra","Manipur",
  "Meghalaya","Mizoram","Nagaland","Odisha","Punjab","Rajasthan","Sikkim","Tamil Nadu","Telangana",
  "Tripura","Uttar Pradesh","Uttarakhand","West Bengal",
  "Delhi","Chandigarh","Puducherry","Jammu & Kashmir","Ladakh","Lakshadweep",
  "Andaman & Nicobar Islands","Dadra & Nagar Haveli and Daman & Diu",
];
